<template>
  <v-app id="session">
    <div v-if="errored">
      <v-alert :type="type">
        {{ message }}
      </v-alert>
    </div>

    <v-container id="signinup-form" class="fill-height">
      <v-row align="center" justify="center" no-gutters>
        <v-col cols="12" sm="8" md="8">
          <v-card class="elevation-12 card" :loading="loading">
            <template slot="progress">
              <v-progress-linear
                color="primary"
                height="7"
                indeterminate
              ></v-progress-linear>
            </template>
            <v-window v-model="step">
              <!-- Inicio de Sesión-->
              <v-window-item :value="1">
                <v-row class>
                  <v-col cols="12" md="4" class="vcenter" :class="`${bgColor}`">
                    <div>
                      <v-layout mt-4 column align-center>
                        <v-flex>
                            <v-img height="200" width="200" :src="require('@/assets/camion.png')"></v-img>
                        </v-flex>
                      </v-layout>
                      <v-card-text>
                        <h1 class="text-center headline mb-3 white--text">
                          Luthue Digital
                        </h1>
                        <h5 class="text-center overline mb-3 white--text">
                          Rotulador de Preventa
                        </h5>
                      </v-card-text>
                    </div>
                  </v-col>
                  <v-col cols="12" md="8" class="pt-6 pb-6">
                    <v-form ref="form" v-model="valid" lazy-validation>
                      <v-card-text>
                        <h1
                          class="text-center display-1 mb-10"
                          :class="`${bgColor}--text`"
                        >
                          Iniciar sesión
                        </h1>
                        <v-text-field
                          v-model="correo"
                          label="Correo"
                          append-icon="mdi-account"
                          type="text"
                          :rules="rules_login"
                          color="primary"
                        />
                        <v-text-field
                          :append-icon="
                            login_password_show ? 'mdi-eye' : 'mdi-eye-off'
                          "
                          :type="login_password_show ? 'text' : 'password'"
                          v-model="contrasena"
                          label="Contraseña"
                          :rules="rules_login"
                          v-on:keyup.enter="iniciar_sesion"
                          @click:append="
                            login_password_show = !login_password_show
                          "
                          color="primary"
                        />
                        <div class="text-center mt-6">  
                          <v-btn
                            large
                            color="primary"
                            dark
                            @click="iniciar_sesion"
                            >Entrar</v-btn
                          >
                        </div>
                      </v-card-text>
                    </v-form>
                  </v-col>
                </v-row>
              </v-window-item>
              <!-- CAMBIO DE CONTRASEÑA -->
              <v-window-item :value="2">
                <v-row class>
                  <v-col cols="12" md="4" class="vcenter" :class="`${bgColor}`">
                    <div>
                      <v-layout mt-4 column align-center>
                        <v-flex>
                            <v-img height="200" width="200" :src="require('@/assets/camion.png')"></v-img>
                        </v-flex>
                      </v-layout>
                      <v-card-text>
                        <h1 class="text-center headline mb-3 white--text">
                          Luthue Digital
                        </h1>
                        <h5 class="text-center overline mb-3 white--text">
                          Rotulador de Preventa
                        </h5>
                      </v-card-text>
                    </div>
                  </v-col>
                  <v-col cols="12" md="8" class="pt-6 pb-6">
                    <v-form ref="form_change" v-model="valid" lazy-validation>
                      <v-card-text>
                        <h1
                          class="text-center display-1 mb-10"
                          :class="`${bgColor}--text`"
                        >
                          Cambio de Contraseña
                        </h1>
                        <v-text-field
                          v-model="correo"
                          label="Correo de Cliente"
                          append-icon="mdi-account"
                          hint="Correo de Cliente Asignado"
                          type="text"
                          :rules="rules_login"
                          color="primary"
                        />
                        <div class="text-center mt-6">  
                          <v-btn
                            large
                            color="primary"
                            dark
                            @click="cambiarContrasena"
                            >Enviar Contraseña Correo</v-btn
                          >
                           <p
                          class="text-center mt-5"
                          style="cursor: pointer"
                          :class="`${bgColor}--text`"
                          @click="step = 1"
                        >
                          Iniciar Sesión
                        </p>
                        </div>
                      </v-card-text>
                    </v-form>
                  </v-col>
                </v-row>
              </v-window-item>
            </v-window>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import service from "@/core/Servicio.js";
export default {
  props: {
    source: {
      type: String,
      default: "",
    },
    bgColor: {
      type: String,
      default: "primary",
    },
    expressColor: {
      type: String,
      default: "error",
    },
    fgColor: {
      type: String,
      default: "white",
    },
  },
  data: () => ({
    footer: {
      inset: true,
    },
    step: 1,
    login_password_show: false,
    register_show_password: false,
    register_show_confirm_password: false,
    message: "",
    valid: false,
    errored: false,
    loading: false,
    cliente: {
      nombre: null,
      contrasena: null,
      correo: null,
      cliente_id_luthue: null,
    },
    contrasena: null,
    correo: null,
    type: "error",
    rules_login: [(v) => !!v || "Campo Requerido"],
  }),
  mounted() {},
  methods: {
    cambiarContrasena(){
      if (this.$refs.form_change.validate()) {
          console.log(this.correo);
      }
    },
    iniciar_sesion() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        let params = {
          contrasena: this.contrasena,
          correo : this.correo
        };
        service
          .login(params)
          .then((response) => {
            this.loading = false;
            if (response.data.response_flag == 1) {
              //Si es correcto se guardan las variables del cliente
              let cliente = response.data.response;
              localStorage.setItem("id" , cliente.id);
              localStorage.setItem("nombre" , cliente.nombre);
              localStorage.setItem("telefono" , cliente.telefono);
              localStorage.setItem("correo" , cliente.correo);
              localStorage.setItem("rfc" , cliente.rfc);
              localStorage.setItem("contrato" , cliente.contrato);
              localStorage.setItem("contrasena" , cliente.contrasena);
              this.$router.push("nuevo");
            } else {
              this.errored = true;
              this.message = "Correo o Contraseña incorrectos";
              setTimeout(() => (this.errored = false), 1000);
            }
          })
          .catch(() => {
            this.loading = false;
            this.errored = true;
            this.message =
              "Ocurrio un problema en el sitio, comunicarse con el encargado de sistemas";
            setTimeout(() => (this.errored = false), 1000);
          });
      } 
    },
  },
};
</script>